import { render, staticRenderFns } from "./change-role.vue?vue&type=template&id=b7aadef2"
import script from "./change-role.vue?vue&type=script&lang=js"
export * from "./change-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports